import { render, staticRenderFns } from "./PaginatorTable.vue?vue&type=template&id=76fec804&scoped=true"
import script from "./PaginatorTable.vue?vue&type=script&lang=js"
export * from "./PaginatorTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fec804",
  null
  
)

export default component.exports